import { render, staticRenderFns } from "./LogisticsBlock.vue?vue&type=template&id=46b26cb6&scoped=true"
import script from "./LogisticsBlock.vue?vue&type=script&lang=js"
export * from "./LogisticsBlock.vue?vue&type=script&lang=js"
import style0 from "./LogisticsBlock.vue?vue&type=style&index=0&id=46b26cb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b26cb6",
  null
  
)

export default component.exports